import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

// Store controller state at module level
let currentController = null

export const annotateFile = async (fileId, annotation, type) => {
  try {
    // Safely abort previous request if it exists
    if (currentController) {
      currentController.abort()
    }
    currentController = new AbortController()

    const { data } = await axios.post(
      `${API_BASE_URL}/${type === 'VCF' ? 'vcf' : 'fastq'}/annotatev2`,
      {
        fileId,
        annotation,
      },
      {
        signal: currentController.signal,
      },
    )

    return data
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('Annotation request was aborted')
    }
    if (error.response) {
      if (error.response.status === 402) {
        return {
          error: 'Insufficient balance',
          needed_balance: error.response.data.needed_balance,
        }
      }
      console.log(`Error: ${error.response.statusText}`)
    } else {
      console.log('Error: No response from server')
    }
    throw error
  } finally {
    // Reset controller only after request is fully complete
    currentController = null
  }
}

export const getPlots = async (fileId) => {
  const { data } = await axios.get(`${API_BASE_URL}/fastq/plots/${fileId}`)

  return data
}

export const getSarekDashboard = async (fileId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/fastq/dashboard/${fileId}`)
    return response // Return the entire response object
  } catch (error) {
    console.error('Error fetching dashboard:', error)
    throw error // Rethrow the error to be handled by the caller
  }
}

export const getOntDashboard = async (ontBamId, reportType = 'snp') => {
  try {
    const response = await axios.get(`${API_BASE_URL}/ont/dashboard/${ontBamId}?report_type=${reportType}`)
    return response
  } catch (error) {
    console.error('Error fetching ONT dashboard:', error)
    throw error
  }
}

export const getPacBioDashboard = async (pacbioBamId, reportType = 'multiqc') => {
  try {
    const response = await axios.get(`${API_BASE_URL}/pacbio/dashboard/${pacbioBamId}?report_type=${reportType}`)
    return response
  } catch (error) {
    console.error('Error fetching PacBio dashboard:', error)
    throw error
  }
}
